import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Str from "shared/components/Str";
import MessagesIcon from "routers/Desktop/NavBar/components/icons/Messages.svg";
import { ICON_SIZE } from "routers/Desktop/NavBar/components/util/constants";

const MessagesButtonContent = ({ messagesCount, isSelected }) => {
	return (
		<div className={classnames("navbar-link navbar-message-btn-container", { isSelected })}>
			<div className="navbar-link-icon-container">
				<MessagesIcon
					className={classnames("navbar-link-icon", {
						isSelected,
					})}
					width={ICON_SIZE}
					height={ICON_SIZE}
				/>
				{/**
					 * Mailbox inbox count can be jQuery-ed in via InstantEvents.
					 * Need id="navbar-mailbox" so that the count
					 * can be injected into the dom.
				*/}
				<div id={messagesCount !== null ? "" : "navbar-mailbox"}>
					{
						messagesCount
							? (
								<div className="badge navbar-likes-count">
									<span className="count">
										{messagesCount > 99 ? "99+" : messagesCount}
									</span>
								</div>
							)
							: null
					}
				</div>
			</div>
			<span className="navbar-link-text">
				<Str>Messages</Str>
			</span>
		</div>
	);
};

MessagesButtonContent.propTypes = {
	messagesCount: PropTypes.number,
	isSelected: PropTypes.bool,
};

MessagesButtonContent.defaultProps = {
	messagesCount: null,
	isSelected: false,
};

export default MessagesButtonContent;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/MessagesButtonContent.jsx